import ASwitch from './index.vue';

ASwitch.install = app => {
  app.component(ASwitch.name, ASwitch);
};

export default ASwitch;
